import React, {
  useCallback,
  useEffect,
  useState,
  createContext,
  useRef,
} from "react";
import { getDownloadUserAccountInfo } from "./utils";
import { useContext } from "react";

//Create the Context
const DownloadUserContext = createContext();

//Create a provider Component
export const DownloadUserProvider = ({ children }) => {
  const [downloadUserAccountInfo, setDownloadUserAccountInfo] = useState(null);
  const [selectedDownloadUserAccountInfo, setSelectedDownloadUserAccountInfo] =
    useState(null);
  const [isNewUser, setIsNewUser] = useState(false);
  const [reload, setReload] = useState(true);
  const [formData, setFormData] = useState({});
  const recaptchaRef = useRef();

  const [authenticationChecked, setAuthenticationChecked] = useState(null);

  const loadDownloadUserAccountInfo = useCallback(() => {
    getDownloadUserAccountInfo(
      setDownloadUserAccountInfo,
      setIsNewUser,
      setAuthenticationChecked,
    );
  });
  useEffect(() => {
    loadDownloadUserAccountInfo();
    setReload(false);
  }, [reload]);
  return (
    <DownloadUserContext.Provider
      value={{
        downloadUserAccountInfo,
        setDownloadUserAccountInfo,
        selectedDownloadUserAccountInfo,
        formData,
        setFormData,
        setSelectedDownloadUserAccountInfo,
        setReload,
        isNewUser,
        setIsNewUser,
        recaptchaRef,
        authenticationChecked,
        setAuthenticationChecked,
      }}
    >
      {children}
    </DownloadUserContext.Provider>
  );
};

// Custom hook to use the DownloadUserContext
export const useDownloadUserAccount = () => {
  const context = useContext(DownloadUserContext);
  if (!context) {
    throw new Error("useDownloadUser must be used within DownloadUserProvider");
  }
  return context;
};
